import React, { useState, useEffect } from 'react';
import '../styles/Modal.css';

const Modal = ({ isOpen, onClose, onOkClick, title, children, hideOkButton, autoCloseTime }) => {
  const [countdown, setCountdown] = useState(null);
  
  useEffect(() => {
    // Reset countdown when modal opens
    if (isOpen && autoCloseTime) {
      // Convert milliseconds to seconds and round up
      setCountdown(Math.ceil(autoCloseTime / 1000));
      
      // Set up the countdown timer
      const countdownInterval = setInterval(() => {
        setCountdown(prevCount => {
          if (prevCount <= 1) {
            clearInterval(countdownInterval);
            // Close the modal when countdown reaches 0
            if (onOkClick) {
              onOkClick();
            } else {
              onClose();
            }
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
      
      // Clean up the interval when component unmounts or modal closes
      return () => clearInterval(countdownInterval);
    }
  }, [isOpen, autoCloseTime, onClose, onOkClick]);
  
  if (!isOpen) return null;

  // Handle OK button click
  const handleOkClick = () => {
    // If a custom OK handler is provided, use it
    if (onOkClick) {
      onOkClick();
    } else {
      // Otherwise, just close the modal
      onClose();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">
          {children}
          {countdown && (
            <div className="modal-countdown">
              Schließt automatisch in {countdown} Sekunden...
            </div>
          )}
        </div>
        <div className="modal-footer">
          {!hideOkButton && (
            <button className="modal-ok-button" onClick={handleOkClick}>
              OK {countdown && `(${countdown})`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
